import CustomComponent from '../CustomComponent';

export class InfoScreenHeaderComponent extends CustomComponent {
	static key = 'lta-info-screen-header';

	static get observedAttributes() {
		return ['title', 'description', 'classes', 'stripes'];
	}

	render() {
		const { title = '', description = '', classes = '', stripes = 'stripes-top-left' } = this.props;

		const classNames = [
			'lta-info-screen-header',
			'lta-color-splash',
			stripes ? `lta-color-splash--${stripes}` : '',
			classes
		]
			.filter(Boolean)
			.join(' ');

		return `
			<div class="${classNames}">
				<div class="lta-info-screen-header__inner l-grid">
					${title ? `<h1 class="lta-info-screen-header__title">${title}</h1>` : ''}
					${description ? `<p class="lta-info-screen-header__description">${description}</p>` : ''}
				</div>
			</div>
		`;
	}
}

export default InfoScreenHeaderComponent;
